import { render, staticRenderFns } from "./ActorDetails.vue?vue&type=template&id=433aca8a&scoped=true&"
import script from "./ActorDetails.vue?vue&type=script&lang=js&"
export * from "./ActorDetails.vue?vue&type=script&lang=js&"
import style0 from "./ActorDetails.vue?vue&type=style&index=0&id=433aca8a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433aca8a",
  null
  
)

export default component.exports